<template>
    <div class="uf-value">
        <div class="uf-value_value">
            <slot></slot>
            <span class="uf-value_type" v-text="type"></span>
        </div>
        <div class="uf-value_label" v-text="label"></div>
    </div>
</template>

<script>
export default {
  name: 'UfLabel',
  props: {
    type: { type: String, default: '' },
    label: { type: String, default: '' },
  },
};
</script>

<style lang="stylus">
    .uf-value {
        text-align: center
        .uf-value_value {
            font-size: 1.1rem
            font-weight: bold
        }
        .uf-value_type {
            font-size: 1rem
        }
        .uf-value_label {
            margin-top: -2px
        }
        &:first-child > * {
            text-align: left
        }
        &:last-child > * {
            text-align: right
        }


    }

    .is-inverted .uf-value  {
        color: #fff
        text-shadow: -1px -1px 0 rgba(#000000, .87), 1px -1px 0 rgba(#000000, .87), -1px 1px 0 rgba(#000000, .87), 1px 1px 0 rgba(#000000, .87);
    }
</style>
